import React from 'react';

import Spin from 'antd/es/spin';
import Divider from 'antd/es/divider';

import { Title } from 'components/Text';
import { Row, Col } from 'components/layout';
import CameraView from 'components/process/CameraView';
import ProcessTimeline from 'components/process/ProcessTimeline';

import UnloadingPercChart from '../components/UnloadingPercChart';
import UnloadingCpmChart from '../components/UnloadingCpmChart';
import UnloadingDepthChart from '../components/UnloadingDepthChart';

import { PROCESS_CHARTS_SYNC_ID } from '../constants';

const ProcessCharts = ({ process, timeline, history, isLoading,logs }) => {

  if (isLoading) {
    return (
      <Row justify="center" align="center">
        <Spin
            size={30}
            style={{ width: '100%', padding: '36px' }}
          />
      </Row>
    );
  }

  return (
    <>
      <Row justify="center" style={{ padding: '16px 24px' }}>
        <Col span={24}>
          {process && (
            <CameraView
              mode="debug"
              style={{ maxWidth: '800px' }}
              doorId={process.door_id}
              startTs={process.docked_at}
              endTs={process.undocked_at || (new Date() / 1000)}
              tzOffset={process.timezone_offset}
              logs={logs}
              imgProps={{
                style: {
                  maxWidth: '750px'
                }
              }}
            />
          )}
        </Col>
      </Row>
      <Row style={{ padding: '16px 0' }}>
        <Col span={24}>
          <ProcessTimeline
            container={timeline}
            showContextMenu={false}
          />
        </Col>
      </Row>

      <Divider />

      <Row style={{ padding: '16px 0' }}>
        <Col span={24}>
          <Title level={4}>Running vs Predicted Process</Title>
            <UnloadingPercChart stats={history} syncId={PROCESS_CHARTS_SYNC_ID}
              tzOffset={process && process.timezone_offset} />
        </Col>
      </Row>
      <Row style={{ padding: '16px 0' }}>
        <Col span={24}>
        <Title level={4}>Last Depth</Title>
            <UnloadingDepthChart stats={history} syncId={PROCESS_CHARTS_SYNC_ID} 
              tzOffset={process && process.timezone_offset} />
        </Col>
      </Row>
      <Row style={{ padding: '16px 0' }}>
        <Col span={24}>
          <Title level={4}>Avg vs Last 5 min CPM</Title>
            <UnloadingCpmChart stats={history} syncId={PROCESS_CHARTS_SYNC_ID}
              tzOffset={process && process.timezone_offset} />
        </Col>
      </Row>
    </>
  );

};

export default ProcessCharts;
